import { CircularProgress } from '@mui/material'
import { FC, MouseEventHandler } from 'react'
import { loadingComponent } from '@omnea-app/frontend/components/shared/Loading/loadingComponent'
import { ListRisksResponse } from '../../../../../../list/useListRisks'
import { useListRiskAttributes } from '../../../../../../settings/hooks/useListRiskAttributes'
import { RiskMatrixScoreChipLoaded } from './content/RiskMatrixScoreChipLoaded'
import { RiskChipTooltipMetadata } from './content/types'

export type RiskMatrixScoreChipProps = {
  probabilityId: string
  impactId: string
  hideNameInLabel?: boolean
  onClick?: MouseEventHandler
  showZeroScaleChip: boolean
  labelPrefixType?: 'inherent' | 'residual'
  size?: 'small' | 'medium'
  risksForQuestion?: NonNullable<ListRisksResponse['data']>
  setRiskIdToEdit?: (value: string) => void
} & RiskChipTooltipMetadata

export const RiskMatrixScoreChip: FC<RiskMatrixScoreChipProps> = loadingComponent(
  ({ probabilityId, impactId, hideNameInLabel, onClick, showZeroScaleChip, risksForQuestion, setRiskIdToEdit, ...props }) => {
    const { data } = useListRiskAttributes()
    if (!data) return null

    return (
      <RiskMatrixScoreChipLoaded
        probabilityId={probabilityId}
        impactId={impactId}
        hideNameInLabel={hideNameInLabel}
        onClick={onClick}
        showZeroScaleChip={showZeroScaleChip}
        risksForQuestion={risksForQuestion}
        setRiskIdToEdit={setRiskIdToEdit}
        {...props}
        {...data}
      />
    )
  },
  {
    loadingFallback: <CircularProgress size={16} sx={{ color: 'fg.default' }} />,
  }
)
